import PrepareBillingForm from "./PrepareBillingForm";

export default function AddPrepareBilling() {
  return <PrepareBillingForm />;
}
